// extracted by mini-css-extract-plugin
module.exports = {"card":"SpecialIcons_card__vRg0E","specialIcons":"SpecialIcons_specialIcons__y7eKv","specialText":"SpecialIcons_specialText__yqbFW"};